import descriptionValidator from '../../../../../@shared/descriptionValidator';
import useDialog from '../../../../../@shared/Dialogs/useDialog';
import useRequestForm from '../../../../../@shared/Forms/RequestForm/useRequestForm';
import LoadingModal from '../../../../auth/features/ForgotDialogues/LoadingModal';
import boxesEndpoints from '../../../box.endpoints';
import { BoxMovementCode } from '../../../box.models';
import SolicitationFormDialogPresentation from '../solicitationDialog';
import useBoxDataGridSlice from '../useBoxDataGrid';

const SolicitCancellationFormDialog = () => {
  const boxDataGridRedux = useBoxDataGridSlice();
  const { showSolicitCancellationFormDialog, selectedRows } = boxDataGridRedux.useSelector();

  const form = useRequestForm({
    validatorSchema: descriptionValidator,
    submitRequest: (obj) =>
      boxesEndpoints.solicitMovement(
        obj.description,
        selectedRows,
        BoxMovementCode.SolicitCancellation
      ),
  });
  const dialog = useDialog({
    handleOpen: () => boxDataGridRedux.openSolicitCancellationDialog(),
    handleClose: () => boxDataGridRedux.closeSolicitCancellationDialog(),
  });

  form.useHandleSuccess(() => {
    boxDataGridRedux.setAnySubmit(form.submitResponse.success);
    form.submitResponse.reset();
  });

  dialog.useOpen(showSolicitCancellationFormDialog);
  dialog.useClose(form.submitResponse.success);

  if (form.submitResponse.loading) return <LoadingModal />;
  return (
    <SolicitationFormDialogPresentation
      descriptions={selectedRows}
      title="Solicitação para cancelamento"
      onHide={() => dialog.close()}
      show={dialog.show}
      size="lg"
      method="post"
      onSubmit={form.handleSubmit(form.onSubmit)}
      control={form.control}
      validated={form.validator.validated}
      errors={form.validator.errors}
    />
  );
};

export default SolicitCancellationFormDialog;
